//综合指数定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 所属区域
 */
class District extends UltMeta {
    YANGTZE_RIVER_DELTA = new Meta(1, "长三角");
}

export const DISTRICT = new District();
/**
 * 取样市场
 */
class SamplingMarket extends UltMeta {
    JIANG_YIN = new Meta(1, "江阴");
    WU_HU = new Meta(2, "芜湖");
}

export const SAMPLING_MARKET = new SamplingMarket();
/**
 * 状态
 */
class State extends UltMeta {
    UNPUBLISHED = new Meta(1, "未发布");
    PUBLISHED = new Meta(2, "已发布");
}

export const STATE = new State();
/**
 * 范围
 */
class Scope extends UltMeta {
    LATEST_ONE_WEEK = new Meta(1, "近一周");
    LATEST_ONE_MONTH = new Meta(2, "近一月");
    LATEST_ONE_YEAR = new Meta(3, "近一年");
}

export const SCOPE = new Scope();

/**
 *
 * */
class Type extends UltMeta {
    COMPOSITE_INDEX = new Meta(1, "综合指数");
    NATURAL_SAND = new Meta(2, "天然砂", 1);
    GRAVEL = new Meta(3, "碎石", 3);
    MECHANIZED_SAND = new Meta(4, "机制砂", 2);
}
export const TYPE = new Type();
